import Services from '../tools/Services';

export default class AircraftTrack {
    constructor(map) {
        this.map = map;
        this.timer = undefined;
        this.showTrack = false;
        this.aircraft = {};
        this.json = [];
        this.path = [];
        this.speeds = [];
        this.eventListener();
    }

    loadTrack = async () => {

        // Post
        let id = this.aircraft.id;
        let res = await Services.post('aircraft2/getTrack', {
            id
        });

        // If bad request, exit
        if (res === undefined)
            return;

        // Error
        if (res.status === 'error')
            return console.error('Aircraft/get error: ' + res.error, res);

        // Success
        let t = res.track;

        // Get only Lat & Lon for the Polyline
        let track = t.map((c, i) => {
            return {
                lat: c.lat,
                lng: c.lon
            };
        });

        // If track is the same as the last call dont do anything
        if (track === this.json)
            return;

        this.json = track;

        this.addTrack(track);
        this.setTimer();
    }

    // Timer to get the track every 5s
    setTimer() {
        this.timer = setTimeout(() => {
            clearTimeout(this.timer);
            this.loadTrack();
        }, 5000);
    }

    // Listen for a click on the aircraft or the registration
    eventListener() {
        // Listen for a click on aircraft or aircraft list
        window.addEventListener('aircraftClick', (e) => {

            if (this.path.length > 0)
                this.path.map((l, i) => {
                    if (l && l.setMap) {
                        l.setMap(this.track);
                        this.path.splice(i, 1);
                    }
                });
            
            this.aircraft = e.detail;
            this.loadTrack();

        });

        // Listen for the aircraft dialog close to hide the track
        window.addEventListener('hideTrack', (e) => {
            
            clearTimeout(this.timer);
            
            this.path.map((l, i) => {
                if (l && l.setMap) {
                    l.setMap(null);
                    this.path.splice(i, 1);
                }
            });
        });
    }

    addTrack() {

        if (this.path.length < 1 || this.path.length > 1) {
            this.path.map((a, i) => {
                a.setMap(null);
                this.path.splice(i, 1);
                return null;
            });
        }

        // Create Polyline
        let path = new window.google.maps.Polyline({
            path: this.json,
            geodesic: true,
            strokeColor: '#DB4437',
            strokeWeight: 3,
            strokeOpacity: 1.0,
        });

        // Push it to this.path to be able to do .setMap later
        this.path.push(path);

        // no map
        if (!this.map) {
            console.error('addTrack this.map == null');
            return;
        }

        // Set it in the map
        path.setMap(this.map);
        let ev = new CustomEvent('newTrackDrawn', {
            detail: [path, this.aircraft]
        });

        window.dispatchEvent(ev);
    }
}

